"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactPagination = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../common");
const CompactPagination_styles_1 = require("./CompactPagination.styles");
const helpers_1 = require("../../helpers");
const icons_1 = require("../../icons");
const Text_1 = require("../../Text");
const View_1 = require("../../View");
exports.CompactPagination = (0, helpers_1.createUIElement)('CompactPagination', (_a, ref) => {
    var { className, disabled = false, hasPrev = true, hasNext = true, currentPage, onPrevClick, onNextClick, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "disabled", "hasPrev", "hasNext", "currentPage", "onPrevClick", "onNextClick", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const spaceLeft = (0, react_1.useMemo)(() => (hasPrev ? undefined : View_1.INDENT.l), [hasPrev]);
    const spaceRight = (0, react_1.useMemo)(() => (hasNext ? undefined : View_1.INDENT.l), [hasNext]);
    const view = (0, react_1.useMemo)(() => (disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary), [disabled]);
    const hasPage = (0, react_1.useMemo)(() => currentPage !== undefined, [currentPage]);
    return (react_1.default.createElement(CompactPagination_styles_1.StyledCompactPagination, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, spaceLeft: spaceLeft, spaceRight: spaceRight, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-CompactPagination', className) }),
        hasPrev && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "compact-pagination-previous-button", onClick: onPrevClick, disabled: disabled },
            react_1.default.createElement(icons_1.PreviousIcon, null))),
        react_1.default.createElement(CompactPagination_styles_1.StyledCompactPaginationSeparator, null),
        hasPage && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CompactPagination_styles_1.StyledCompactPaginationPageCounter, { view: view }, currentPage),
            react_1.default.createElement(CompactPagination_styles_1.StyledCompactPaginationSeparator, null))),
        hasNext && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "compact-pagination-next-button", onClick: onNextClick, disabled: disabled },
            react_1.default.createElement(icons_1.NextIcon, null)))));
});
//# sourceMappingURL=CompactPagination.js.map